export default __webpack_public_path__ + "static/Agrandir-Wide-d284b43af9ee5f07c9cd386202b8f553.woff2";